import ajax from '@/libs/Ajax'

export default {
    queryImplClassList(params) {
        return ajax.get('/aseapi/console/sysmgr/implclassmgr/listImplClass', {params: params})
    },
    saveImplClass(data) {
        return ajax.post('/aseapi/console/sysmgr/implclassmgr/saveImplClass', data)
    },
    updateImplClass(data) {
        return ajax.post('/aseapi/console/sysmgr/implclassmgr/updateImplClass', data)
    },
    delImplClass(params) {
        return ajax.post('/aseapi/console/sysmgr/implclassmgr/deleteImplClass', params)
    }
}
